import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../data/content";

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative flex min-h-[90vh] w-full items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.ctaBg} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/75" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]" />
      </div>
      <div className="pad-x relative z-10 w-full">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="display-title max-w-[16ch] text-white"
        >
          Let's create something <span className="text-gold">unforgettable.</span>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-12"
        >
          <Link
            to="/contact"
            data-testid="cta-start-project"
            className="group inline-flex items-center gap-3 rounded-full bg-white px-10 py-5 text-sm font-semibold uppercase tracking-[0.12em] text-black transition-colors duration-300 hover:bg-gold hover:text-white"
          >
            Start a Project
            <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-0.5" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
